module.exports = __webpack_public_path__ + "img/env_1.cb477a2c.jpg";